<template>
    <v-dialog
      v-model="show"
      max-width="400px"
      @click:outside="cancel"
    >
      <v-card>
        <v-card-title>
          <span class="headline">
            Unset audio
          </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              {{ this.name }} ({{ this.audioId }})
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancel"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="unsetAudio"
          >
            Unset
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>

export default {
  name: 'AudioDialogUnset',
  props: {
    fromId: [Number, String],
    name: {
      type: String,
      default: 'default',
    },
    playlistType: {
      type: String,
      default: '',
    },
    audioId: Number,
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },

  mounted() {

  },

  methods: {
    unsetAudio() {
      this.$requestHelpers
        .post(
          'api/admin/audio/unsetFrom',
          {
            audio_id: this.audioId,
            audiable_id: this.fromId,
            audiable_type: this.playlistType,
          },
        ).then(() => {
          this.$emit('unset', true);
        }).catch(() => {
          this.$emit('unset', false);
        });
    },
    cancel() {
      this.$emit('update:show', false);
    },
  },
};
</script>
